import AddIcon from '@mui/icons-material/Add';
import { Box, Button, Stack, Typography } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectContactList } from '../../redux/reducers/organizationReducer';
import AddContactModal from './AddContactModal';
import EditContactModal from './EditContactModal';

export default function ContactsList() {
  const { t } = useTranslation();
  const contactList = useSelector(selectContactList);
  const [openAddContact, setOpenAddContact] = useState(false);
  const [openEditContact, setOpenEditContact] = useState(false);
  const [selectedId, setSelectedId] = useState('');
  const [editMode, setEditMode] = useState(false);

  const columns = [
    {
      field: 'contactName',
      headerName: t('nameVar'),
      flex: 1,
      editable: false,
    },
    {
      field: 'contactEmail',
      headerName: t('email'),
      flex: 1,
      editable: false,
    },
    {
      field: 'contactPhone',
      headerName: t('phone'),
      flex: 1,
      editable: false,
    },
  ];

  const rows = contactList.map((contact) => ({
    id: contact.id,
    contactName: contact.name,
    contactEmail: contact.email,
    contactPhone: contact.phone,
  }));

  const handleAddContactModal = () => {
    setOpenAddContact(!openAddContact);
  };

  const handleEditContactModal = (event) => {
    setSelectedId(event.id);
    setOpenEditContact(!openEditContact);
  };

  const handleEditMode = () => {
    setEditMode(!editMode);
  };

  const handleCloseEditModal = () => {
    setOpenEditContact(false);
    setEditMode(false);
    setSelectedId('');
  };

  return (
    <>
      {openAddContact && (
        <AddContactModal
          handleClose={handleAddContactModal}
        />
      )}
      {openEditContact && (
        <EditContactModal
          handleClose={handleCloseEditModal}
          contactId={selectedId}
        />
      )}
      <Stack direction="row" justifyContent="space-between">
        <Typography id='contacts-header' variant="soaTitle">{t('person.selector.contacts')}</Typography>
        <Button id='add-contact' variant="contained" endIcon={<AddIcon />} onClick={() => handleAddContactModal()}>{t('person.contact.add')}</Button>
      </Stack>
      <Stack direction="column" spacing={2}>
        <Typography
          variant="body1"
          sx={{
            wordWrap: 'break-word',
            overflowWrap: 'break-word',
          }}
        >
          {t('organization.contactDesc')}
        </Typography>
        <DataGrid
          autoHeight
          disableRowSelectionOnClick
          columns={columns}
          rows={rows}
          onRowClick={(event) => handleEditContactModal(event)}
        />
      </Stack>
    </>
  );
}
